import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getViewModeStore } from '../../misc-utils/store-utils';
import { AbstractSensorContentStore } from '../../state/abstract-sensor-content-store';

@Component({
  selector: 'h3-objectless-view-settings-opacity-slider',
  templateUrl: './objectless-view-settings-opacity-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ObjectlessViewSettingsOpacitySliderComponent
  extends DirectiveSuperclass
  implements OnInit
{
  @Input({ required: true }) defaultLayerOpacity!: number;

  layerOpacityDisabled$!: Observable<boolean>;
  layerOpacityStore!: Store<number>;
  eventSettingName = 'opacity';

  private store = inject(AbstractSensorContentStore);

  ngOnInit() {
    this.layerOpacityStore = this.store.getLayerSettingsStore()('opacity');
    this.layerOpacityDisabled$ = getViewModeStore(this.store).$.pipe(
      map((viewMode) => viewMode === 'layers' || viewMode === 'none'),
    );
  }
}
